import React from "react";
import styled from "styled-components";
import { media } from "utils/style";

const Container = ({ children, noTabletPadding, ...props }) => (
  <Div {...props} noTabletPadding={noTabletPadding}>
    {children}
  </Div>
);

export default Container;

const Div = styled.div`
  max-width: 810px;
  margin: 0 auto;
  padding: 80px 0;

  ${media.smalldesktop`
    max-width: 700px;    
  `}

  ${media.tablet`
    max-width: 512px;
    padding-left: ${({ noTabletPadding }) => (!noTabletPadding ? "50px" : "0")}
  `}

  ${media.mobile`
    max-width: 90%;
    margin: 40px auto;
    padding: 0;
  `};
`;
